import * as Yup from "yup";
import Messages from "../languages/Messages";

export const AgencySchema = Yup.object().shape({
    name: Yup.string().required("Required field!"),
    typeOfAgency: Yup.string().required("Required field!"),
    typeOfIdentity: Yup.string().required("Required field!"),
});
